/**
 * Indore homepage popular strip: fixed order and on-card promo tags.
 * Usernames match DB / `turf-config.json` (TurfBooking.in).
 * GT / “AR Turf and Cafe” uses `gt-turf-and-food-court` in DB (not `gt-turf-and-cafe`).
 *
 * Order: recommended → featured+partnered (SP) → partnered (Energym).
 */
export interface HomepageIndoreFeaturedEntry {
  username: string;
  /** Shown on venue cards instead of default amenity badges. */
  promoBadges: readonly string[];
}

export const HOMEPAGE_INDORE_FEATURED_ENTRIES: readonly HomepageIndoreFeaturedEntry[] = [
  { username: "super-over-turf-indore", promoBadges: ["Recommended"] },
//   { username: "all-rounder-turf", promoBadges: ["Recommended"] },
  { username: "tims-turf-and-cafe", promoBadges: ["Recommended"] },
  { username: "gt-turf-and-food-court", promoBadges: ["Recommended"] },
//   { username: "the-indore-oval", promoBadges: ["Recommended"] },
  { username: "sp-turf-and-cafe", promoBadges: ["Featured", "Partnered"] },
  { username: "energym-turf", promoBadges: ["Partnered"] },
];

/** @deprecated Use HOMEPAGE_INDORE_FEATURED_ENTRIES */
export const HOMEPAGE_INDORE_FEATURED_USERNAMES: readonly string[] =
  HOMEPAGE_INDORE_FEATURED_ENTRIES.map((e) => e.username);
